<template>
    <div class="bricks bg-[length:900px] md:bg-[length:1300px] -mt-16 md:-mt-0"></div>
    <div class="w-full bg-primary-default -mt-1">
        <div style="max-width: 1400px;" class="mx-auto p-12 text-left flex">
            <div class="flex flex-col gap-24 items-center w-full">
                <div class="flex flex-col items-center">
                    <p class="text-sm text-white">Schau' doch auch mal hier vorbei.</p>
                    <div class="flex gap-2 mt-3 flex-wrap justify-center">
                        <template v-for="i in links" :key="i">
                            <a class="flex flex-col p-3 rounded-md bg-white max-h-20" style="aspect-ratio: 2/1;"
                                :href="i.url" :title="i.title">
                                <img :src="`/assets/websites/${i.img}`" class="h-full w-full object-contain"
                                    draggable="false" :alt="`Die Website von ${i.name} öffnen`">
                            </a>
                        </template>
                    </div>
                </div>
                <div class="flex justify-center md:justify-between w-full flex-wrap gap-12">
                    <p class="text-sm text-white">Copyright © Pfarramt Rastenberg 2024</p>
                    <div class="flex gap-3 text-white text-sm">
                        <button class="hover:underline" @click="$router.push('/impressum')">Impressum</button> |
                        <button class="hover:underline" @click="$router.push('/datenschutz')">Datenschutz</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            links: [
                {
                    title: 'Stiftung Finneck besuchen',
                    url: 'https://www.stiftung-finneck.de/',
                    img: "finneck.webp"
                },
                {
                    title: 'Orgelförderverein Rastenberg e.V. besuchen',
                    url: 'https://www.orgelfoerderverein-rastenberg.de/',
                    img: "orgel-ev.webp"
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.bricks {
    background-image: url('@/assets/bricks-footer.png');
    background-repeat: repeat-x;
    background-position: bottom;
    width: 100%;
    height: 250px;
}
</style>